import type { ReactNode } from 'react';
import styles from '../ChatMarkdown.module.css';
import {
  classifyParagraph,
  type HastNode,
  type ParagraphKind,
} from './classify-paragraph';

const KIND_CLASS: Record<ParagraphKind, string | undefined> = {
  label: styles.leadLabel,
  takeaway: styles.takeaway,
  body: undefined,
};

export function MarkdownParagraph({
  node,
  children,
}: Readonly<{ node?: HastNode; children?: ReactNode }>) {
  return <p className={KIND_CLASS[classifyParagraph(node)]}>{children}</p>;
}
